<template>
  <div class="d-flex justify-center what-we-can">
    <div class="block-width">
      <div class="d-flex justify-center">
        <h1 class="mt-0 mb-3 text-center w-58">{{ $t('what_we_can') }}</h1>
      </div>
      <div class="d-flex justify-between mb-1 flex-wrap">
        <div class="info-card info-card__blue">
          <img src="@/assets/images/card-images/info-card-icon-1.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_1') }}</p>
          <p class="text-body" style="line-height: 150%">{{ $t('what_we_can_2') }}</p>
          <img src="@/assets/images/card-images/info-card-corner-blue.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-1.svg"
            class="big-image-1"
            alt="main_image"
            loading="lazy"
            width="389"
            height="233"
            style="aspect-ratio: auto 389 / 233;"
          />
        </div>
        <div class="info-card info-card__green">
          <img src="@/assets/images/card-images/info-card-icon-2.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_3') }}</p>
          <p class="text-body" style="line-height: 150%">{{ $t('what_we_can_4') }}</p>
          <img src="@/assets/images/card-images/info-card-corner-green.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-2.svg"
            class="big-image-2"
            alt="main_image"
            loading="lazy"
            width="360"
            height="166"
            style="aspect-ratio: auto 360 / 166;"
          />
        </div>
        <div class="info-card info-card__violet">
          <img src="@/assets/images/card-images/info-card-icon-3.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_5') }}</p>
          <p class="text-body" style="line-height: 150%">{{ $t('what_we_can_6') }}</p>
          <img src="@/assets/images/card-images/info-card-corner-violet.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-3.svg"
            class="big-image-3"
            alt="main_image"
            loading="lazy"
            width="463"
            height="197"
            style="aspect-ratio: auto 463 / 197;"
          />
        </div>
        <div class="info-card info-card__orange">
          <img src="@/assets/images/card-images/info-card-icon-4.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_7') }}</p>
          <p class="text-body" style="line-height: 150%">{{ $t('what_we_can_8') }}</p>
          <img src="@/assets/images/card-images/info-card-corner-orange.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-4.svg"
            class="big-image-4"
            alt="main_image"
            loading="lazy"
            width="546"
            height="334"
            style="aspect-ratio: auto 546 / 334;"
          />
        </div>
        <div class="info-card info-card__cyan">
          <img src="@/assets/images/card-images/info-card-icon-5.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_9') }}</p>
          <p class="text-body" style="line-height: 150%">
            {{ $t('what_we_can_10') }}
          </p>
          <img src="@/assets/images/card-images/info-card-corner-cyan.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-5.svg"
            class="big-image-5"
            alt="main_image"
            loading="lazy"
            width="489"
            height="151"
            style="aspect-ratio: auto 489 / 151;"
          />
        </div>
        <div class="info-card info-card__light-blue">
          <img src="@/assets/images/card-images/info-card-icon-6.svg" class="mb-1" alt="icon" loading="lazy"/>
          <p class="text-large fw-600 mb-1">{{ $t('what_we_can_11') }}</p>
          <p class="text-body" style="line-height: 150%">
            {{ $t('what_we_can_12') }}
          </p>
          <img src="@/assets/images/card-images/info-card-corner-light-blue.svg" class="corner-image" alt="corner"/>
          <img
            src="@/assets/images/card-images/info-card-6.svg"
            class="big-image-6"
            alt="main_image"
            loading="lazy"
            width="261"
            height="545"
            style="aspect-ratio: auto 261 / 545;"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
</script>